import {
  allTypesOption,
  defaultAssessmentTypes,
  quickActionTypes,
} from '../constants/strings';
import { customColors } from '../utilities';

export const modals = {
  createAssessment: 'createAssessmentModal',
  createTemplate: 'createTemplateModal',
  createIncident: 'createIncidentModal',
  createWorkspace: 'createWorkspaceModal',
  noWorkspace: 'noWorkspaceModal',
  fileUpload: 'fileUploadModal',
  recordMeeting: 'recordMeetingModal',
  announcement: 'announcementModal',
  quickAction: 'quickActionModal',
  observation: 'observationModal',
  task: 'taskModal',
  role: 'roleModal',
  certificate: 'certificateModal',
  confirmation: 'confirmationModal',
  CPA: 'CPAModal',
  audit: 'createAuditModal',
  vectorResponse: 'vectorResponseModal',
  multiFileUpload: 'multiFileUploadModal',
  board: 'createBoardModal',
  qr: 'qrModal',
  openLink: 'openLinkModal',
  reminder: 'reminderModal',
  conditionalAction: 'conditionalActionModal',
  actionItem: 'actionItemModal',
  addRisk: 'addRiskModal',
  addRiskRegistry: 'addRiskRegistryModal',
  checkIn: 'checkInModal',
  fileMove: 'fileMoveModal',
  completeTask: 'completeTaskModal',
  timecard: 'timecardModal',
};

const taskAssessmentTypes = Object.values(defaultAssessmentTypes).filter(
  ({ key }) => key !== 'INCIDENT' && key !== 'OBSERVATION' && key !== 'AUDIT',
);

export const modalDefaultState = {
  createAssessmentModal: {
    show: false,
    types: [],
    incidentId: null,
    timecardId: null,
    asset: null,
    modalTitle: null,
    template: null,
    participants: null,
    type: allTypesOption,
    subject: null,
    dataWorkspaceId: null,
    location: null,
    anonymous: false,
    urlParams: [
      { param: 'modalName', value: modals.createAssessment },
      { param: 'type', paramTarget: 'key', value: null },
      { param: 'template', paramTarget: 'id', value: null },
      { param: 'asset', paramTarget: 'id', value: null },
    ],
  },
  createTemplateModal: {
    show: false,
    types: [],
    title: '',
    description: '',
    reviewRequired: false,
    analysisRequested: false,
    allWorkspaces: false,
    modalTitle: null,
    type: defaultAssessmentTypes.fleet,
    options: { allWorkspaces: true, secondSight: true, approvalRequired: true },
  },
  createIncidentModal: {
    show: false,
    modalTitle: 'Report Incident',
    type: undefined,
    subtype: undefined,
    participants: undefined,
    observation: undefined,
    description: undefined,
    dateOfIncident: undefined,
    location: undefined,
    images: [],
    id: null,
    onClose: () => {},
    navigate: false,
    aviationQuestions: null,
    anonymous: false,
    urlParams: [{ param: 'modalName', value: modals.createIncident }],
  },
  createWorkspaceModal: {
    show: false,
    title: '',
    description: '',
  },
  noWorkspaceModal: {
    show: false,
    modalTitle: 'Select Workspace',
    allowClose: true,
  },
  fileUploadModal: {
    show: false,
    modalTitle: null,
    status: null,
    type: null,
    asset: null,
    expires: null,
    user: null,
    downloadAllowed: true,
    name: null,
    onLoading: () => {},
    fileToUpload: null,
    simple: false,
    allWorkspaces: false,
    parentId: null,
    size: null,
    onSubmit: () => {},
    assessment: false,
    previousAdditional: null,
    previousValue: null,
    fromAsset: false,
    accept: '*',
    description: '',
    requirement: null,
    hidden: false,
    onClose: () => {},
    isCertification: false,
    riskRegistryId: null,
  },
  recordMeetingModal: {
    show: false,
    inspectionId: null,
    startNew: null,
    refetch: () => {},
    onView: null,
    urlParams: [{ param: 'modalName', value: modals.recordMeeting }],
  },
  announcementModal: {
    show: false,
    announcement: null,
    status: 'READ',
    id: null,
  },
  quickActionModal: {
    color: customColors.BLUE,
    name: null,
    icon: null,
    type: defaultAssessmentTypes.fleet,
    template: null,
    asset: null,
    workspace: null,
    quickActionType: quickActionTypes.userLevel,
    show: false,
    url: null,
    refetch: () => {},
    urlParams: [
      { param: 'modalName', value: modals.task },
      { param: 'modalName', value: modals.role },
      { param: 'type', paramTarget: 'key', value: null },
      { param: 'template', paramTarget: 'id', value: null },
      { param: 'workspace', paramTarget: 'id', value: null },
    ],
  },
  observationModal: {
    show: false,
    dateTime: undefined,
    location: null,
    participants: undefined,
    negative: false,
    description: undefined,
    anonymous: false,
    workspaceId: undefined,
    images: [],
    refetch: () => {},
    templateId: undefined,
    questions: [],
    preview: false,
    private: false,
    incidentId: null,
    urlParams: [{ param: 'modalName', value: modals.observation }],
    user: null,
    type: 'POSITIVE',
  },
  taskModal: {
    show: false,
    title: '',
    interval: 'ONE_TIME',
    endDate: '',
    types: taskAssessmentTypes,
    templateType: allTypesOption,
    type: null,
    subtype: null,
    taskType: 'OBSERVATION',
    template: null,
    task: {},
    modalTitle: null,
    assignees: [],
    vehicles: [],
    vehicleAssigneeOverrides: {},
    taskWorkspace: null,
    target: null,
    vehicle: null,
    urlParams: [
      { param: 'modalName', value: modals.task },
      { param: 'templateType', paramTarget: 'key', value: null },
      { param: 'template', paramTarget: 'id', value: null },
      { param: 'workspace', paramTarget: 'id', value: null },
      { param: 'taskType', value: null },
    ],
  },
  roleModal: {
    show: false,
    roleTitle: '',
    title: '',
    roleDescription: '',
    requirementTitle: '',
    requirementDescription: '',
    modalTitle: null,
    readOnly: false,
    urlParams: [{ param: 'modalName', value: modals.role }],
    rolePermissions: null,
    roleId: null,
  },
  certificateModal: {
    show: false,
    certificateId: null,
    requirement: null,
    userId: null,
    certificateData: null,
    files: [],
    onComplete: () => {},
  },
  confirmationModal: {
    show: false,
    title: undefined,
    description: undefined,
    highlight: false,
    wordsToHighlight: [],
    variant: undefined,
    buttonText: undefined,
    onHide: () => {},
    onSubmit: () => {},
    icon: 'warning',
    doubleConfirm: false,
    confirmText: '',
    textInput: false,
    textInputTitle: '',
    cancelText: undefined,
    onCancel: undefined,
    hideSubmit: false,
  },
  CPAModal: {
    show: false,
    onSubmit: () => {},
  },
  createAuditModal: {
    show: false,
    subject: null,
    customer: null,
    dateCreated: null,
    auditType: 'Internal',
    asset: null,
    template: null,
    urlParams: [
      { param: 'modalName', value: modals.createAssessment },
      { param: 'type', paramTarget: 'key', value: null },
      { param: 'template', paramTarget: 'id', value: null },
      { param: 'asset', paramTarget: 'id', value: null },
      { param: 'workspace', paramTarget: 'id', value: null },
      { param: 'taskId', value: null },
    ],
  },
  vectorResponseModal: {
    show: false,
    loadingSubscription: false,
  },
  multiFileUploadModal: {
    show: false,
    accept: '.pdf',
    isCertification: false,
    requirements: [],
    onSubmit: () => {},
    refetch: () => {},
  },
  createBoardModal: {
    show: false,
  },
  qrModal: {
    show: false,
    key: null,
    pathname: null,
  },
  openLinkModal: {
    show: false,
  },
  reminderModal: {
    show: false,
    onClose: () => {},
    onClick: () => {},
    message: '',
    url: null,
    urlParams: [{ param: 'modalName', value: modals.reminder }],
  },
  conditionalActionModal: {
    show: false,
    actions: [],
  },
  actionItemModal: {
    show: false,
  },
  addRiskModal: {
    show: false,
    impact: null,
    probability: null,
    description: null,
    category: null,
    notes: null,
  },
  addRiskRegistryModal: {
    show: false,
  },
  checkInModal: {
    show: false,
    intervalOptions: [
      { value: 'MINUTES', label: 'Minutes' },
      { value: 'HOURS', label: 'Hours' },
    ],
    refetch: () => {},
  },
  fileMoveModal: {
    show: false,
    onClose: () => {},
    fileId: null,
  },
  completeTaskModal: {
    asset: null,
    show: false,
    template: null,
    workspace: null,
    taskType: null,
    task: {},
    onStart: () => {},
    participants: [],
    location: null,
    urlParams: [
      { param: 'modalName', value: modals.completeTask },
      { param: 'taskId', value: null },
      { param: 'template', paramTarget: 'id', value: null },
      { param: 'workspace', paramTarget: 'id', value: null },
      { param: 'taskType', value: null },
      { param: 'asset', value: null, paramTarget: 'id' },
    ],
  },
  timecardModal: {
    show: false,
    description: null,
    copyFromPrev: false,
  },
};
